export default __webpack_public_path__ + "static/media/328.872b5abe.png";